import React, { useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
} from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import MultiSelect from 'components/material/MultiSelect'
import { Input, SelectedMenu } from 'components'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  filterDataFromToday,
  formatCostumDateMonthNoForUI,
} from 'utils/formatDate'
import PropTypes from 'prop-types'
import { events as eventsModule } from '../../redux/modules'
import AddEditQuestions from './AddEditQuestions'
import { TRAININGS_GAME } from 'constants/calender'
import { TASK_GROUP_DUE_DATES } from 'constants/taskGroups'

const AddEditMatchTaskGroup = ({
  taskGroup,
  isEditMode,
  playersList,
  handleInput,
  handlePlayerChange,
  handleCheckboxSelectAllPlayers,
  handleCreate,
  handleUpdate,
  questions,
  handleQuestion,
  addNewQuestion,
  setQuestions,
  setTaskGroup,
  selectAllPlayers,
  match: {
    params: { seasonId },
  },
  fetchCalendarEvents,
  dateFormat,
  eventId,
}) => {
  const [matches, setMatches] = useState([])
  const [selectedPlayers, setSelectedPlayer] = useState([])
  const [selectedMatches, setSelectedMatches] = useState([])
  const [selectAllEvents, setSelectAllEvents] = useState(eventId <= 0)

  const filterMatches = (data) => {
    // Filter out dates in the past or falsey values
    return filterDataFromToday(data.map((d) => ({ ...d, date: d.event_date })))
  }
  const handleCheckboxSelectAllTrainings = (event) => {
    const { checked } = event.target

    setSelectAllEvents(checked)

    if (checked) {
      const filteredMatches = filterMatches(matches)

      setTaskGroup({
        ...taskGroup,
        eventUuids: [...new Set(filteredMatches.map((p) => p.uuid))],
        [`error_eventUuids`]: filteredMatches.length <= 0,
      })
      setSelectedMatches(filteredMatches)
    }
  }

  const handleEventChange = (value) => {
    setTaskGroup({
      ...taskGroup,
      eventUuids: [...new Set(value.map((p) => p.uuid))],
      [`error_eventUuids`]: value.length <= 0,
    })
    setSelectedMatches(value)
  }
  useEffect(() => {
    fetchCalendarEvents(seasonId).then((res) => {
      const response = res.response.data
      const tempMatches = response.events
        .filter((s) => s.relation === 'match')
        .map((match) => ({
          id: match.uuid,
          uuid: match.uuid,
          label: `${formatCostumDateMonthNoForUI(
            match.date,
            dateFormat
          )} Opponent: ${match.opponent ? match.opponent : ''}`,
          event_date: match.date,
        }))
      setMatches(tempMatches)
      const isSelectAllEvents =
        taskGroup && taskGroup?.eventUuids?.length > 0
          ? taskGroup?.eventUuids?.length === tempMatches?.length
          : eventId <= 0
      setSelectAllEvents(isSelectAllEvents)
      if (isSelectAllEvents) {
        const filteredMatches = filterMatches(tempMatches)

        setTaskGroup({
          ...taskGroup,
          eventUuids: [...new Set(filteredMatches.map((t) => t.uuid))],
          [`error_eventUuids`]: filteredMatches.length <= 0,
        })
        setSelectedMatches(filteredMatches)
      } else {
        setSelectedMatches(
          eventId
            ? tempMatches.filter(
                (match) => eventId === match.uuid
              )
            : tempMatches.filter((match) =>
                taskGroup?.eventUuids?.includes(match.uuid)
              )
        )

        if (eventId > 0) {
          setTaskGroup({
            ...taskGroup,
            eventUuids: [
              ...tempMatches
                .filter(
                  (match) =>
                    taskGroup?.eventUuids?.includes(match.uuid) ||
                    eventId === match.uuid
                )
                .map((p) => p.uuid),
            ],
          })
        }
      }
    })
  }, [])
  useEffect(() => {
    setSelectedPlayer(
      playersList.filter(
        (player) =>
          taskGroup?.modelUuids?.includes(player.uuid)
      )
    )
  }, [taskGroup.modelUuids, playersList])

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(selectAllEvents)}
              onChange={handleCheckboxSelectAllTrainings}
              color="secondary"
            />
          }
          label={<Translate id="task-management.all-matches" />}
          disabled={!!eventId}
        />
        {!selectAllEvents && (
          <MultiSelect
            options={matches}
            handleSelection={handleEventChange}
            label={<Translate id="task-management.select-match" />}
            selectedValues={selectedMatches}
            error={taskGroup?.error_eventUuids}
            helperText={
              taskGroup?.error_eventUuids && (
                <Translate id="task-management.match-validation" />
              )
            }
            limitTags={5}
            disabled={!!eventId}
          />
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(selectAllPlayers)}
              onChange={handleCheckboxSelectAllPlayers}
              color="secondary"
            />
          }
          label={<Translate id="task-management.visible-to-all" />}
        />
        {!selectAllPlayers && (
          <MultiSelect
            options={playersList}
            handleSelection={handlePlayerChange}
            label={<Translate id="task-management.select-player" />}
            selectedValues={selectedPlayers}
            error={taskGroup?.error_modelUuids}
            helperText={
              taskGroup?.error_modelUuids && (
                <Translate id="task-management.player-validation" />
              )
            }
          />
        )}
        <Input
          label={<Translate id="articles.title" />}
          margin="dense"
          onChange={handleInput}
          name="title"
          value={taskGroup?.title}
          error={taskGroup?.error_title}
          helperText={
            taskGroup?.error_title && (
              <Translate id="task-management.title-validation" />
            )
          }
          required
        />
        <Input
          label={<Translate id="drills.description" />}
          margin="dense"
          onChange={handleInput}
          name="description"
          value={taskGroup.description}
        />
        <SelectedMenu
          id="due-date"
          name="dueDateOffset"
          value={taskGroup.dueDateOffset}
          margin="dense"
          onChange={handleInput}
          label={<Translate id="task-management.due-date" />}
        >
          {TASK_GROUP_DUE_DATES.map((p) => (
            <MenuItem key={p.value} value={p.value}>
              {p.title}
            </MenuItem>
          ))}
        </SelectedMenu>
      </Grid>

      <AddEditQuestions
        questions={questions}
        handleQuestion={handleQuestion}
        addNewQuestion={addNewQuestion}
        setQuestions={setQuestions}
        taskGroup={taskGroup}
        setTaskGroup={setTaskGroup}
      />

      <Button
        onClick={
          !isEditMode
            ? () => handleCreate(TRAININGS_GAME.match)
            : () => handleUpdate(TRAININGS_GAME.match, taskGroup.uuid)
        }
        color="primary"
        variant="contained"
        style={{ marginTop: '1.5rem' }}
        fullWidth
        disabled={
          taskGroup?.error_title ||
          taskGroup?.error_modelUuids ||
          taskGroup?.error_eventUuids
        }
      >
        {!isEditMode ? (
          <Translate id="button.add" />
        ) : (
          <Translate id="button.update" />
        )}
      </Button>
    </Grid>
  )
}
AddEditMatchTaskGroup.defaultProps = {
  eventId: 0,
  match: {
    params: {},
  },
}

AddEditMatchTaskGroup.propTypes = {
  taskGroup: PropTypes.shape().isRequired,
  isEditMode: PropTypes.bool.isRequired,
  handleInput: PropTypes.func.isRequired,
  handlePlayerChange: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  playersList: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  handleQuestion: PropTypes.func.isRequired,
  addNewQuestion: PropTypes.func.isRequired,
  setQuestions: PropTypes.func.isRequired,
  setTaskGroup: PropTypes.func.isRequired,
  handleCheckboxSelectAllPlayers: PropTypes.func.isRequired,
  selectAllPlayers: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape(),
  }),
  fetchCalendarEvents: PropTypes.func.isRequired,
  dateFormat: PropTypes.string.isRequired,
  eventId: PropTypes.number,
}
export default compose(
  withRouter,
  connect(
    ({ team, auth }) => ({
      team,
      dateFormat: auth.user.datetime_format,
    }),
    {
      fetchCalendarEvents: eventsModule.fetchCalendarEvents,
    }
  )
)(AddEditMatchTaskGroup)
